import Vue from 'vue';
import Errors from '../classes/errors';

Vue.component('owner-manual-search-component', {
    props: {
        manuals: Array,
    },

    data() {
        return {
            searchQuery: '',
            searchResults: null,
            vinError: false,
            awaitingSearch: false,
            errors: new Errors(),
        };
    },

    watch: {
        vinError(value) {
            if (!value) {
                this.errors.clear();
                return;
            }

            this.errors.record({ vin: ['owner-manual-error'] });
        },
    },

    mounted() {
        document.addEventListener('keydown', this.setSearchQueryOnEnter);
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.setSearchQueryOnEnter);
    },

    methods: {
        setSearchQueryOnEnter(event) {
            if (event.key === 'Enter') {
                this.setSearchQuery();
            }
        },
        throttledSearch() {
            if (!this.awaitingSearch) {
                setTimeout(() => {
                    this.search();
                    this.awaitingSearch = false;
                }, 500);
            }
            this.awaitingSearch = true;
        },
        setSearchQuery() {
            // The Services VIN field is a nested new-input-component, so it doesn't update searchQuery
            const vinInput = this.$el.querySelector('#vin');
            if (vinInput) {
                this.searchQuery = vinInput.value.trim();
            }

            this.search(this.searchQuery);
        },
        search(searchProperty) {
            this.vinError = false;
            const search = (searchProperty || this.searchQuery).toUpperCase();

            if (search.length !== 17 && search.length > 0) {
                this.vinError = true;
                return;
            }

            // Extract relevant parts from VIN: first 8 chars + 10th & 11th chars
            const firstEight = search.slice(0, 8);
            const tenth = search[9];
            const eleventh = search[10];

            let results = [];
            this.manuals.forEach((current) => {
                current.codes.forEach((code) => {
                    let isMatch = false;

                    // Case 1: Code with wildcard (e.g. LSJA2439*N)
                    if (code[8] === '*') {
                        // For wildcard case, match first 8 chars + 11th char (ignore 10th)
                        const codeFirstEight = code.slice(0, 8);
                        const codeEleventh = code.slice(9, 10);

                        isMatch =
                            codeFirstEight === firstEight &&
                            codeEleventh === eleventh;
                    }
                    // Case 2: Regular code (e.g. LSJWH409PN)
                    else {
                        // For regular case, match all parts (first 8 + 10th + 11th)
                        isMatch = code === firstEight + tenth + eleventh;
                    }

                    // If we have a match, add the manuals to results
                    if (isMatch) {
                        current.manuals.forEach((manual) => {
                            results.push(manual);
                        });
                    }
                });
            });

            this.searchResults = results;
        },
    },
});
